import React from 'react';
import { useFormikContext } from 'formik';

//Componente para mostrar feedback de totales en la orden
function ResumePaymentCoverage() {
    const { values } = useFormikContext();

    const contadoTotalPayed = Number(values.contadoTotalPayed || 0); //total pagado a contado
    const creditoTotalPayed = Number(values.creditoTotalPayed || 0); //total pagado a credito

    const totalOrden= Number(values.total || 0);

    const contadoTotalInvoice = Number(values.contadoTotalInvoice || 0);
    const creditoTotalInvoice = Number(values.creditoTotalInvoice || 0);

    const totalPagado = contadoTotalPayed + creditoTotalPayed;

    // Si hay penalización final, ese será el total a pagar
    const penalizacionFinal = Number(values.servicio_muerto_monto_penalizacion); 

    const totalFacturado =
    !values.factura_requeridaa && penalizacionFinal > 0
        ? penalizacionFinal
        : values.factura_requeridaa
        ? contadoTotalInvoice + creditoTotalInvoice
        : totalOrden;

    const tolerance = 1.00;

    function formatNumberWithCommas(number) {
        if (number || number === 0) {
            const roundedNumber = parseFloat(number).toFixed(2);
            return roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return '';
    }

    let alertType = 'success';
    let iconClass = 'fa-face-smile';
    let mensaje = '✅ El total de la orden ha sido completamente cubierto con los pagos.';
    
    if (totalPagado === 0) {
        alertType = 'warning';
        iconClass = 'fa-face-meh';
        mensaje = <>⚠️ El total pagado está en <strong>$0.00</strong>. Revisa si es correcto.</>;
    } else if (totalPagado > totalFacturado + tolerance) {
        alertType = 'danger';
        iconClass = 'fa-face-surprise';
        mensaje = <>❗ Se ha <strong>pagado de más</strong> por <strong>${formatNumberWithCommas(totalPagado - totalFacturado)}</strong>.</>;
    } else if (totalPagado < totalFacturado - tolerance) {
        alertType = 'warning';
        iconClass = 'fa-face-meh';
        mensaje = <>⚠️ Aún falta por pagar <strong>${formatNumberWithCommas(totalFacturado - totalPagado)}</strong> para cubrir el total facturado.</>;
    } else {
        alertType = 'success';
        iconClass = 'fa-face-smile';
        mensaje = '✅ El total de la orden ha sido completamente cubierto con los pagos.';
    }
    

    return (
        <div className={`note alert-${alertType} mb-2`}>
            <div className="note-icon">
                <i className={`fa ${iconClass}`}></i>
            </div>
            <div className="note-content">
                {/* <h5><b>Resumen de cobertura de pagos</b></h5> */}
                <p>
                    Total a pagar: <strong>${formatNumberWithCommas(totalFacturado)}</strong><br />
                </p>
                <p>
                    Total pagado hasta ahora (contado + crédito): <strong>${formatNumberWithCommas(totalPagado)}</strong><br />
                    <br />
                    {mensaje}
                </p>

                <hr />

            </div>
        </div>
    );
}

export default ResumePaymentCoverage;
//